<template>
  <div class="tr-test game-tr-test-multi" :class="[{ 'full-screen-scroll': startGameConfig.scrollOff }]">
    <div v-if="objectImageExist(imageData)" class="main-image-container" :style="getImageStyle(imageData)"></div>
    <div
      class="overflow-element"
      :class="[{ 'overflow-with-image': objectImageExist(imageData) }]"
      :style="getStyle(imageData)"
    >
      <div
        class="element-container"
        :class="[
          { 'question-container-image': isImageInQuestionInQuestion(element) },
          { 'element-container-vertical': element.vertical },
          { block: inputStatus(elementIndex) === 'correct' },
        ]"
        :style="getElementStyle(element)"
        v-for="(element, elementIndex) in questionsList"
        :key="'element_' + elementIndex"
        :id="'element_' + elementIndex"
      >
        <div class="question-container inner-element-container" v-if="element.question">
          <div class="question-text">{{ element.question }}</div>
        </div>
        <div class="answer-container inner-element-container">
          <div
            class="answer-item"
            @click="resetCheckStatus"
            v-for="(answer, answerIndex) in element.answers"
            :key="answerIndex"
          >
            <div class="" :style="getAnswerStyle(answer)">
              <label
                class="label-container"
                :class="[{ block: selected['element_' + elementIndex + '_' + answerIndex].block }]"
              >
                <div class="text-container" v-if="isText(answer)" v-html="answer.text"></div>
                <div class="image-container" :style="'background-image: url(' + getImage(answer) + ');'" v-else></div>
                <tr-check-box
                  :checkbox-data-model="selected['element_' + elementIndex + '_' + answerIndex]"
                  :main-index="elementIndex"
                  :index="answerIndex"
                ></tr-check-box>
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import defaultMixin from '../../mixins/defaultMixinV2';
import * as utils from '../../Utils/inputUtilsV2';
import TrCheckBox from './TrCheckBox/TrCheckBoxV2';
export default {
  name: 'tr-test-multi-checkbox-v2',
  components: { TrCheckBox },
  props: {
    startGameConfig: {
      type: Object,
      default: function () {
        return {};
      },
    },
    assets: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  mixins: [defaultMixin],
  data() {
    return {
      baseQuestionsList: [],
      manualElementHeight: this.startGameConfig.questionElementHeight,
      questonShuffle: this.startGameConfig.shuffle,
      selected: [],
      imageData: {},
    };
  },
  created() {},
  beforeMount() {
    this.gameInit();
  },
  mounted() {},
  methods: {
    gameInit() {
      // this.baseQuestionsList = this.prepareData();
      this.questionsList = this.prepareData();
      // this.questionsList = _.flatten(this.questionsList);
      _.each(_.cloneDeep(this.questionsList), (question, questionIndex) => {
        _.each(question.answers, (answer, answerIndex) => {
          this.selected = _.assign({}, this.selected, {
            ['element_' + questionIndex + '_' + answerIndex]: {
              correct: answer.correct || false,
              value: false,
              block: false,
              status: 'rest',
            },
          });
        });
        _.each(question.answers, (answer, answerIndex) => {
          this.answerList = Object.assign({}, this.answerList, {
            ['element_' + questionIndex + '_' + answerIndex]: false,
          });
          this.questionsList[questionIndex].answers[answerIndex] = Object.assign(
            {},
            this.questionsList[questionIndex].answers[answerIndex],
            {
              value: 'element_' + questionIndex + '_' + answerIndex,
              checked: false,
            }
          );
        });
      });
      // console.log('this.selected', this.selected);
      // // console.log( '  this.answerList', this.answerList );
      // console.log('  this.questionsList', this.questionsList);
    },
    /**
     * test if object objectExist
     * @method objectExist
     * @param  {*}    item testiing element
     * @return {Boolean}         true if is object
     */
    objectExist(item) {
      return _.isObject(item) && !_.isNil(item.imagePath);
    },
    getImage(item) {
      return 'static/' + item.imagePath;
      // return 'assets/config/' + item.imagePath;
    },
    inputStatus(index) {
      let element = 'element_' + index;
      let status = 'unset';
      if (this.$store.getters.gameCheckSwitch && this.selected[element] === 'CORRECT') {
        status = 'correct';
      } else if (this.$store.getters.gameCheckSwitch) {
        status = 'incorrect';
      }
      if (
        document.querySelector(['#element_', index].join('')) &&
        document.querySelector(['#element_', index].join('')).classList.contains('block')
      ) {
        status = 'correct';
      }
      return status;
    },
    isText(obj) {
      return _.has(obj, 'text');
    },
    isImageInQuestionInQuestion(obj) {
      return _.some(obj.answers, 'imagePath');
    },
    selectRadioButto(qIndex, aIndex) {
      let element = this.$refs['question' + qIndex + 'answer' + aIndex];
      this.selected['element_' + qIndex] = element[0].value;
    },
    /**
     * test if object objectExist
     * @method objectExist
     * @param  {*}    item testiing element
     * @return {Boolean}         true if is object
     */
    objectImageExist(item) {
      return _.isObject(item) && !_.isNil(item.imagePath);
    },
    /**
     * reset all containerEnd without reset reactivity
     * @method resetGameAction
     */
    resetGameAction() {
      // /** @type {Boolean} set gameCheckSwitch to false - remove statys icons */
      // _.each( _.cloneDeep( this.questionsList ), ( question, questionIndex ) => {
      //   _.each( question.answers, ( answer, answerIndex ) => {
      //     this.selected = _.assign( {}, this.selected, {
      //     [ 'element_' + questionIndex + '_' + answerIndex ]: { correct: answer.correct || false, value: false, block: false, status: 'rest' }
      //     } );
      //   } );
      // } );
      // this.questionsList = this.processQuestionsList();
      this.gameInit();
    },
    checkGameAction() {
      // console.log('this.selected', this.selected);
      let status = _.reduce(
        this.selected,
        (result, item, key) => {
          let temVal = null;
          if ((item.correct === true && item.value === true) || (item.correct === false && item.value === false)) {
            temVal = result && true;
            item.status = 'correct';
            item.block = item.value === true ? true : false;
          } else {
            temVal = false;
            item.status = 'incorrect';
            // this.selected[ key ] = "";
            // setTimeout( () => {
            //   this.selected[ key ].status = "rest";
            //   this.selected[ key ].value = false;
            // }, 2000 );
          }
          return temVal;
        },
        true
      );
      // console.log('ANSWER: ', status);
      if (!status) {
        _.each(this.selected, (item, key) => {
          // console.log('item', item);
        });
      }
      return status;
    },
    prepareData() {
      let selectedItem = {};
      let staticText = [];
      if (this.startGameConfig.pick > 1) {
        selectedItem = _.sampleSize(_.cloneDeep(this.startGameConfig.questionsList), this.startGameConfig.pick);
        // COMBAK: add merge options
      } else if (this.startGameConfig.pick === 1) {
        selectedItem = _.sample(_.cloneDeep(this.startGameConfig.questionsList));
      } else {
        selectedItem = this.startGameConfig;
      }
      if (selectedItem.imageData) {
        this.imageData = selectedItem.imageData;
      } else if (this.startGameConfig.mainImage) {
        this.imageData = this.startGameConfig.mainImage;
      } else if (this.startGameConfig.background) {
        this.imageData = Object.assign({}, { imagePath: this.startGameConfig.background });
      }
      if (selectedItem.pick && selectedItem.pick > 1) {
        this.answers = _.sampleSize(_.cloneDeep(selectedItem.answers), selectedItem.pick);
      } else if (selectedItem.pick && selectedItem.pick === 1) {
        this.answers = _.sampleSize(_.cloneDeep(selectedItem.answers), 1);
      } else {
        this.answers = selectedItem.answers;
      }
      this.answers = _.flatten(
        _.map(this.answers, (item) => {
          if (_.isArray(item.items)) {
            if (item.pick) {
              return item.shuffle
                ? _.shuffle(_.sampleSize(_.cloneDeep(item.items), item.pick))
                : _.sampleSize(_.cloneDeep(item.items), item.pick);
            } else {
              return item.shuffle ? _.shuffle(_.cloneDeep(item.items)) : _.cloneDeep(item.items);
            }
          }
          return item;
        })
      );
      if (this.startGameConfig.staticText) {
        staticText = staticText.length === 0 ? this.startGameConfig.staticText : staticText;
      }
      if (staticText.length > 0) {
        this.staticText = _.map(staticText, (item, index) => {
          if (this.startGameConfig.layoutStaticText) {
            return Object.assign(item, this.startGameConfig.layoutStaticText[index]);
          } else {
            return item;
          }
        });
      }
      this.answers = selectedItem.shuffle ? _.shuffle(_.cloneDeep(this.answers)) : this.answers;
      /**
       * add layout if exist
       * @method if
       * @param  {array} this layoutItems array
       * @return {Boolean}
       */
      if (this.startGameConfig.layoutItems) {
        this.answers = _.map(_.cloneDeep(this.answers), (item, index) => {
          return Object.assign(item, this.startGameConfig.layoutItems[index]);
          // return _.merge( item, this.startGameConfig.layoutItems[ index ] );
        });
      }
      // /**
      //  * box  text aplay
      //  * @type {[type]}
      //  */
      // if (this.startGameConfig.words) {
      //   let syncData = this.startGameConfig.boxConfig.syncData;
      //   this.words = this.startGameConfig.words;
      //   if (this.startGameConfig.boxConfig && syncData) {
      //     this.words = _.intersection(this.startGameConfig.words, _.flattenDeep(_.map(this.answer, (item) => {
      //       if (item[syncData]) {
      //         return [...item[syncData]];
      //       } else if (item.markers) {
      //         return _.flattenDeep(_.map(item.markers, (item) => {
      //           return [...item[syncData]];
      //         }));
      //       }
      //       return [...item[syncData]];
      //     })));
      //   }
      //   this.words = _.shuffle(this.words);
      // }
      this.answers = _.map(this.answers, (item, key) => {
        if (key != 'pick' || key != 'shuffle') {
          return item;
        }
      });
      // let test = _.extend({}, _.omit(selectedItem, ['answers']), { answers: this.answers });
      // return [_.extend({}, _.omit(selectedItem, ['answers']), { answers: this.answers })];
      return selectedItem;
    },
    // processQuestionsList() {
    //   _.each(_.cloneDeep(this.baseQuestionsList), (item, index) => {
    //     if (item.shuffle) {
    //       this.baseQuestionsList[index].answers = _.shuffle(item.answers);
    //     }
    //   });
    //   this.baseQuestionsList = (this.questonShuffle) ? _.shuffle(this.baseQuestionsList) : this.baseQuestionsList;
    //   return this.baseQuestionsList;
    // },
    getImageStyle(imageData) {
      if (_.isObject(imageData) && imageData.imagePath) {
        if (!imageData.pos) {
          imageData = Object.assign({}, imageData, {
            pos: {
              x: 0,
              y: 0,
            },
          });
        }
        if (!imageData.height) {
          imageData = Object.assign({}, imageData, {
            height: 358,
          });
        }
        if (!imageData.width) {
          imageData = Object.assign({}, imageData, {
            width: 1850,
          });
        }
      }
      return _.merge(this.getCustomStyle(imageData), {
        // 'position': 'absolute',
        'background-image': `url(${require(`__staticDir/${this.$store.getters.multibookType}/${imageData.imagePath}`)})`,
        top: utils.elementTopPosition(imageData.pos.y, imageData.offsetVertical),
        left: utils.elementLeftPosition(imageData.pos.x, imageData.offsetHorizontal),
        width: utils.elementWidth(imageData.width),
        height: utils.elementHeight(imageData.height),
      });
    },
    getElementStyle(element) {
      element.offsetVertical = element.offsetVertical
        ? element.offsetVertical
        : this.startGameConfig.questionOffsetVertical;
      element.offsetHorizontal = element.offsetHorizontal
        ? element.offsetHorizontal
        : this.startGameConfig.questionOffsetHorizontal;
      element.width = element.width ? element.width : this.startGameConfig.questionWidth;
      element.height = element.height ? element.height : this.startGameConfig.questionHeight;
      let pos = element.pos ? { x: element.pos.x || 0, y: element.pos.y || 0 } : null;
      let position = element.pos ? 'absolute' : '';
      return _.merge({ position: 'absolute' }, this.getCustomStyle(element), {
        position: position,
        top: pos ? utils.elementTopPosition(element.pos.y, element.offsetVertical) : '',
        left: pos ? utils.elementLeftPosition(element.pos.x, element.offsetHorizontal) : '',
        width: utils.elementWidth(element.width),
        height: utils.elementHeight(element.height),
      });
    },
    getAnswerStyle(item) {
      return _.merge({}, this.getCustomStyle(item));
    },
    getStyle(item) {
      if (!this.startGameConfig.scrollOff) {
        let height;
        /** @type {Number} margin-bottom:10px; in main-image-container */
        let imageMarginBottom = 10;
        if (item.height) {
          /** 795 is height available scen */
          height = 795 - item.height - imageMarginBottom;
          if (!_.isNumber(height) || height < 0) {
            height = undefined;
          }
        }
        return _.merge({ height: [height, 'px'].join('') }, this.getCustomStyle(item));
      } else {
        return _.merge(
          {
            height: ['initial'].join(''),
            overflow: ['hidden'].join(''),
          },
          this.getCustomStyle(item)
        );
      }
    },
    getCustomStyle(item) {
      let customStyle = {};
      if (item.cssStyle) {
        if (_.isObject(item.cssStyle)) {
          customStyle = _.mapKeys(item.cssStyle, function (value, key) {
            return _.toString(key);
          });
        }
      }
      return customStyle;
    },
  },
  computed: {
    processedQuestionsList() {
      return this.processQuestionsList();
    },
  },
};
</script>

<style lang="scss" scoped>
// @import '~pretty-checkbox/src/pretty-checkbox.scss';
@import '~@/assets/sass/variable';
@import '~@/assets/sass/iconColor';
$elementWidth: 1853px;
$elementHeight: 153px;
.label-container {
  @media (min-width: 1200px) {
    max-width: 97%;
    width: 1780px;
  }
}
.full-screen-scroll {
  overflow: auto !important;
}
.game-tr-test-multi {
  position: relative;
  top: 160px;
  left: 11px;
  display: block;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  // height: 865px;
  height: 795px;
  width: 1906px;
  // padding: 160px 56px 127px 11px;
  box-sizing: border-box;
  justify-content: space-between;
  position: relative;
  overflow: hidden;
  font-size: 28px;
  // height: 100%;
  .block {
    pointer-events: none;
  }
  .overflow-element {
    height: 100%;
    overflow: auto;
    overflow-x: hidden;
    .element-container {
      position: relative;
      display: block;
      width: $elementWidth;
      height: $elementHeight;
      border-radius: 20px;
      border: 3px solid $backgroundControlPanelColor;
      margin-bottom: 20px;
      .inner-element-container {
        display: block;
        // position: absolute;
        width: 100%;
        // height: 30%;
      }
      .question-container {
        margin-bottom: 20px;
        // height: 40%;
        // background-color: rgba(227, 230, 123, 0.29);
        .question-text {
          line-height: 28px;
          text-align: left;
          padding-top: 28px;
          padding-left: 35px;
          padding-right: 35px;
        }
      }
      .answer-container {
        height: 60%;
        // background-color: rgba(6, 45, 172, 0.36);
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        align-items: center;
        .answer-item {
          display: flex;
          min-width: 22%;
          justify-content: flex-start;
          align-items: center;
          height: 49px;

          /* The label-container */
          .label-container {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            position: relative;
            height: 49px;
            padding-left: 60px;
            margin-bottom: 12px;
            cursor: pointer;
            // font-size: 22px;
            -webkit-user-select: none;
            -moz-user-select: none;
            -ms-user-select: none;
            user-select: none;
            .text-container {
            }
            .image-container {
              // width: 250px;
              // height: 250px;
              width: 200px;
              height: 180px;
              text-align: left;
              background-position: center;
              background-repeat: no-repeat;
              background-size: contain;
            }
          }
          .block {
            pointer-events: none;
          }
          /* Hide the browser's default radio button */
          .label-container input {
            position: absolute;
            opacity: 0;
            cursor: pointer;
          }

          /* Create a custom radio button */
          .checkmark {
            position: absolute;
            top: 0;
            left: 0;
            height: 49px;
            width: 49px;
            background-image: url('~@/assets/icons/both/game/testIcons/default.png');
            background-position: center;
            background-repeat: no-repeat;
            background-size: contain;
            border-radius: 50%;
          }

          /* On mouse-over, add a grey background color */
          // .label-container:hover input ~ .checkmark {
          //     // background-color: #ccc;
          //     background-image: url("~@/assets/icons/both/game/testIcons/set.png");
          // }

          /* When the radio button is checked, add a blue background */
          .label-container input:checked ~ .checkmark {
            background-image: url('~@/assets/icons/both/game/testIcons/set.png');
          }
          // correct style
          .label-container input:checked ~ .checkmark.correct {
            background-image: url('~@/assets/icons/both/game/testIcons/correct.png');
          }
          // incorrect style
          .label-container input:checked ~ .checkmark.incorrect {
            background-image: url('~@/assets/icons/both/game/testIcons/incorrect.png');
          }

          /* Create the indicator (the dot/circle - hidden when not checked) */
          .checkmark:after {
            content: '';
            position: absolute;
            display: none;
          }

          /* Show the indicator (dot/circle) when checked */
          .label-container input:checked ~ .checkmark:after {
            display: block;
          }

          /* Style the indicator (dot/circle) */
          .label-container .checkmark:after {
            // top: 9px;
            // left: 9px;
            // width: 8px;
            // height: 8px;
            // border-radius: 50%;
            // background: white;
            visibility: hidden;
          }
        }
      }
    }

    .element-container-vertical {
      height: 300px;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      align-items: flex-start;

      .answer-container {
        height: 100%;
        padding-left: 60px;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        align-items: flex-start;
      }
    }
  }
  .main-image-container {
    position: relative;
    display: block;
    width: $elementWidth;
    height: $elementHeight;
    margin-bottom: 10px;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center center;
  }
  .question-container-image {
    height: 300px;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: flex-start;
  }
}
</style>
